import { LitElement, css, html } from 'lit'


export class DzRcSwitch extends LitElement {
  static get properties() {
    return {
      breakpoints: { type: String },  // точки перелома через запятую, или просто одна точка
      axis: { type: String }          // ось x или y для отслеживания изменений
    }
  }

  constructor() {
    super()
    this.axis = "x"
  }

  connectedCallback() {
    super.connectedCallback();
    (new ResizeObserver(() => {
      this.performUpdate()
    })).observe(this)
  }

  getActiveIndex() {
    if (/^(\s*\d+\s*,)*(\s*\d+\s*)$/.test(this.breakpoints)) {
      if (/^[xy]$/.test(this.axis)) {
        let index = 0
        let bbox  = this.getBoundingClientRect()
        let bpts  = this.breakpoints.split(",").map((s) => parseInt(s))
        for (let pt of bpts) {
          if ((this.axis == "x" && bbox.width < pt) || (this.axis == "y" && bbox.height < pt )) {
            return index;
          } 
          index++
        }
        return bpts.length
      }
    }
  }

  update() {
    let active_index = this.getActiveIndex()
    let index = 0
    for (let child of this.children) {
      if (index == active_index) {
        let clone = child.cloneNode(true)
        this.renderRoot.replaceChildren(clone)
      }
      index++
    }
  }

  static get styles() {
    return css`
        :host {
            display: block;
        }
  `}
}

window.customElements.define('dz-rc-switch', DzRcSwitch)
